import {ArticleDateTime} from '@shared/Articles/ArticleSlug/ArticleDateTime/ArticleDateTime';
import {articleTestIds} from '@shared/Articles/ArticleTestIds';
import ProxyImage from '@shared/ProxyImage/ProxyImage';
import classNames from '@sindresorhus/class-names';
import Link from 'next/link';

import {ArticleType} from '@strapi/types';

import styles from './ArticleSelectionCard.module.scss';

type Props = {
  card: ArticleType;
  onArticleClick?: () => void;
  articleUrl: string;
  /**
   * тип карточки в подборке
   * full - карточка с описанием и заголовком (в дефолте описание у карточки скрыто)
   * secondary - карточка без описания
   * blog - карточка без изображения в десктопе
   * carousel - карточка в карусели
   */
  type?: 'full' | 'secondary' | 'blog' | 'carousel';
};
export const ArticleSelectionCard = ({
  card,
  onArticleClick,
  articleUrl,
  type,
}: Props) => {
  const imageAttributes = card?.cardBackgroundImage;
  return (
    <Link
      key={card.cardTitle}
      href={`/${articleUrl}/${card.href}`}
      className={classNames(styles.card, type && styles[type])}
      onClick={onArticleClick}
      data-testid={articleTestIds.proStorePageArticle}
    >
      {imageAttributes && (
        <div className={styles.imageContainer}>
          <ProxyImage className={styles.image} imageData={imageAttributes} />
        </div>
      )}
      <div>
        <ArticleDateTime
          timeToRead={card.timeToRead}
          updatedAt={card.updatedAt}
          publishedAt={card.publishedAt}
          className={styles.time}
        />

        <h2 className={styles.title}>{card.cardTitle}</h2>
        <p className={styles.description}>{card.cardDescription}</p>
      </div>
    </Link>
  );
};
